const isDarkMode = window.matchMedia?.('(prefers-color-scheme: dark)')?.matches
console.log('isDarkMode', isDarkMode)

export const themeColors = {
  text: isDarkMode ? '#FFFFFF' : '#151515',
  background: isDarkMode ? 'black' : 'white',
  border: isDarkMode ? '#212121' : '#E8E8E8',
  assistantBubble: isDarkMode ? '#212121' : '#F7F7F7',
  userBubble: isDarkMode ? '#212121' : '#E8E8E8',
  timestamp: isDarkMode ? '#666666' : '#E8E8E8',
  link: isDarkMode ? '#FF4141' : '#CC0000',
  primary: isDarkMode ? '#FF4141' : '#CC0000',
  feedbackInactive: isDarkMode ? '#E8E8E8' : '#666666',
  grayLine: isDarkMode ? '#212121' : '#E8E8E8',
  suggestionBg: isDarkMode ? '#FFFFFF' : '#151515',
  suggestionBorder: '#C00000',
  navBar: isDarkMode ? '#FFFFFF' : '#333333',
  navBarText: isDarkMode ? '#383838' : '#FFFFFF',
  navBarTextLetsChat: isDarkMode ? '#383838' : '#D6D6D6',
  suggestedChatText: isDarkMode ? '#FF4141' : '#CC0000',
  standardText: isDarkMode ? '#FFFFFF' : '#333333',
  chevron: isDarkMode ? '#FFFFFF' : '#333333',
  arrowUpChatSubmit: isDarkMode ? '#AAAAAA' : '#666666',
  XCancel: isDarkMode ? '#151515' : '#FFFFFF',
  XCancelHover: isDarkMode ? '#D6D6D6' : '#444',
  userAvatarProfile: isDarkMode ? '#FFFFFF' : '#333333',
  chatbubble: isDarkMode ? '#E06666' : '#770101',
}
